/* 
/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 * Analytics msgbus event handler
 */

/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager, globalEngine} from "./Init";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";
import { dataManipulator } from "./common";
import { getDelayedRecordsQueue, LoadScript} from "./bootstrap_web_ext";

// #ENDIF WebPack
// TEMPORTARY LOAD common.js if it wasn't loaded (this will be the case of MTM)
if (typeof dataManipulator !== "object")
{
		LoadScript("common.js");
}

function CreateEventHandler()
{
    var eventhandler =
    {
        "handleEvent": function (event)
        {
            try
            {
                var eventObj = JSON.parse(event);
                var eventType = eventObj.type;
                if (("MessageBusPlugin" == eventType) ||
                    ("InProcAPI Plugin" == eventType)) // in-proc plugin output is the same as for messagebus
                {
                    this._processMsgBusEvent(eventObj.payload);
                }
                else if("UWP_Event" == eventType)
                {
                    this._processAnalyticsAddRecord_v1(eventObj);
                }
                else
                {
                    logWarning("Unexpected message was rejected (unknown type): " + event);
                }
            }
            catch (e)
            {
                logError("Failed to process incoming event: exception = '" + e.message + "'");
            }
        },
        "handleV1Record": function (eventObj)
        {
            this._processAnalyticsAddRecord_v1(eventObj);
        },
        "_processMsgBusEvent": function (eventObj)
        {
            try
            {
                var eventName = eventObj.name;
                var eventPayload = eventObj.payload;

                if ( ("Analytics.v1.AddRecord" == eventName) || 
                     ("Analytics.AddRecord" == eventName) || 
                     ("Analytics.Automation.AddRecord" == eventName) )
                {
                    return this._processAnalyticsAddRecord_v1(eventPayload);
                }

                // Notify the data_collector of a new message in case data points need to be refreshed
                var data_collector = ModuleManager.getSingleton("data_collector");
                data_collector.notifyMsg(eventName);
                
                // A msg the dataset manager is subscribed for can be in observation_analytics too
                var observation_analytics = ModuleManager.getSingleton("observation_analytics");
                observation_analytics.handle(eventName, eventPayload);
            }
            catch (e)
            {
                logError("Failed to process message-bus event: exception = '" + e.message + "'");
            }
        },
        "_normalizePayload": function (recordPayload)
        {
            if (!recordPayload)
            {
                return null;
            }

            var normalizedPayload = {};

            try
            {
                for (var idx in recordPayload)
                {
                    var obj = recordPayload[idx];
                    if (obj instanceof Array)
                    {
                        //Arrays doesn't have key-value pair,so just assign it to the attribute (corner case)
                        normalizedPayload[idx] = obj;
                    }
                    else if (typeof obj == 'object')
                    {
                        for (var key in obj)
                        {
                            var val = obj[key];
                            normalizedPayload[key] = val;
                        }
                    }
                    else
                    {
                        normalizedPayload[idx] = obj;
                    }
                }
            }
            catch (e)
            {
                logError('Exception while normalizing payload: ' + e.message);
            }
            return normalizedPayload;
        },
        "_processAnalyticsAddRecord_v1": function (eventData)
        {
            try
            {
                logDebug("process Analytics.v1.AddRecord event: " + JSON.stringify(eventData));
                var msgName = eventData.unique_id;
                if (!msgName)
                {
                    msgName = eventData.UniqueIdentifier; // API.v2
                }
                var msgPayload = eventData.payload ? this._normalizePayload(eventData.payload) : this._normalizePayload(eventData.data);

                if (!msgPayload)
                {
                    logWarning("event '" + msgName + "': Unable to extract message payload; using an empty one");
                    msgPayload = {};
                }
                
                var msgType = eventData['type'];
                if (msgType)
                {
                    //This is for backwards compatibility with Orion
                    msgPayload["Tracker.Type"] = msgType;
                }

                // Different versions of the API produces different cases for the tracker type
                if(msgPayload["Tracker.Type"] && (typeof msgPayload["Tracker.Type"]  == "string"))
                {
                    msgPayload["Tracker.Type"] = msgPayload["Tracker.Type"].toLowerCase();
                }

                //Add record creation time if it doesn't exist (case of MsgBus API)
                if(msgPayload["__record.created"] == null)
                {
                    var timeNow = new Date();
                    msgPayload["__record.created"] = timeNow.toISOString();
                }

                msgPayload["Hit.UniqueID"] = msgName;
                logDebug("ready to transmit " + JSON.stringify(msgPayload));

                logRawTrack(msgName, JSON.stringify(msgPayload));


                var eventConfigManager = ModuleManager.getSingleton("config_manager");
                var profileNames = eventConfigManager.getProfileNames(msgName);
                if (!profileNames)
                {
                    logInformation("Rejected event '" + msgName + "': missing configuration");
                    var errorTransport = ModuleManager.getSingleton("error_transmitter");
                    errorTransport.transmit(messageName,message,{"level":"warning",
                    "type":{"rejected":msgName+" is missing configuration/profile"}});
                    return;
                }


                var analyticstransport = ModuleManager.getSingleton("transport");
                analyticstransport.transmit(msgName, msgPayload, profileNames, eventConfigManager.getDataSetNames(msgName));
            }
            catch (e)
            {
                logError("Failed to process Analytics.v1.AddRecord message: exception = '" + e.message + "'");
            }
        }
    }

    try
    {
        globalEngine.MessageBusHandler = function (value)
        {
            logInformation("Handling a new event: " + value);
            eventhandler.handleEvent(value);
        };
    }
    catch (e)
    {
        logError("MessageBusHandler redefinition problem: e = " + e.message);
    }
    // Process messages that were received before loading engine.js

    var ProcessOfflineMessages = function()
    {
        try {
            var delayedRecordsQueue = getDelayedRecordsQueue();

            while (false == delayedRecordsQueue.IsEmpty())
            {
                var record = delayedRecordsQueue.Front();
                delayedRecordsQueue.Pop();

                try
                {
                    eventhandler.handleEvent(record);
                }
                catch(e)
                {
                    logError("Error handling record " + record + ". Error Msg: " + e.message );
                }
            }
        }
        catch (e) {
            logError("An exception occured while processing the queued events pre engine.js: " + e.message);
        }
    };

    ProcessOfflineMessages();

    return eventhandler;
}

// register with the factory function with ModuleManager
ModuleManager.registerFactory("event_handler", CreateEventHandler);

//export  {CreateEventHandler};
//globalEngine.FactoryMap["event_handler"] =  CreateEventHandler;
